import { MappedClass, MappedProperty } from '@h5s/util-object';
import { ZPrinterHealthStatus } from './z-printer-health-status';

@MappedClass()
export class ZPrinterSettingsHealthEntry {
  @MappedProperty()
  configured?: boolean;

  @MappedProperty()
  status?: ZPrinterHealthStatus;
}
